import { createContext, FC, ReactNode, useContext, useMemo } from "react";

import OverlayLoading from "src/components/DataStates/OverlayLoading";
import PageError from "src/components/Errors/PageError";
import { useGetCaseTypesSchemasQuery } from "src/graphql/anti-fraud/queries/caseTypes/CaseTypesSchemasQuery";

export type CaseTypesContextValue = {
  caseTypes:
    | {
        code: string;
        name: string;
      }[]
    | null;
};

export const CaseTypesContext = createContext<CaseTypesContextValue>({
  caseTypes: null,
});

export const CaseTypesProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { data: caseTypes, loading, error } = useGetCaseTypesSchemasQuery();

  const contextValue = useMemo(
    () => ({
      caseTypes: caseTypes,
    }),
    [caseTypes]
  );

  return error ? (
    <PageError title={error.title} description={error.message} />
  ) : loading ? (
    <OverlayLoading />
  ) : (
    <CaseTypesContext.Provider value={contextValue}>{children}</CaseTypesContext.Provider>
  );
};

export const useCaseTypes = () => {
  const { caseTypes } = useContext(CaseTypesContext);

  if (!caseTypes) {
    throw new Error(
      "Either `useCurrentUser` was called outside of a `CurrentUserProvider` or the provider was not properly initialized."
    );
  }

  return { caseTypes };
};
